<template>
    <div class="country-picker">
        <van-field
            readonly
            clickable
            border
            :rules="rules"
            :error="false"
            :placeholder="placeholder"
            :label="label"
            :value="selectedText"
            @click="showPicker = true"
            :right-icon="rightIcon"
        />
        <van-action-sheet v-model="showPicker" :title="label" :value="selectedValue" @closed="onClose">
            <van-index-bar :index-list="Object.keys(countryIndex)">
                <template v-for="indexStr in Object.keys(countryIndex)">
                    <van-index-anchor :index="indexStr" :key="indexStr" />
                    <van-cell
                        v-for="countryCode in countryIndex[indexStr]"
                        :title="options[countryCode]"
                        :key="countryCode"
                        @click="doChange(countryCode)"
                    />
                </template>
            </van-index-bar>
        </van-action-sheet>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import countryRegionIndex from "@/country-region-data/country-region-index";
import i18n from "@/locales/i18n";

export default Vue.extend({
    name: "country-region-select",
    data() {
        return {
            showPicker: false,
            selectedValue: this.value,
            options: this.$i18n.messages[this.$i18n.locale]["countries"]
        };
    },
    props: {
        value: {
            required: true
        },
        placeholder: {
            type: String,
            default: i18n.t("common.placeholder.select")
        },
        rightIcon: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            required: true
        },
        rules: Array
    },
    methods: {
        doChange(countryCode) {
            this.selectedValue = countryCode;
            this.$emit("input", _.defaultTo(this.selectedValue, ""));
            this.$emit("on-change", _.defaultTo(this.selectedValue, ""));
            this.onClose();
        },
        onOpen() {
            this.showPicker = true;
        },
        onClose() {
            this.showPicker = false;
        }
    },
    computed: {
        countryIndex() {
            if (this.$i18n.locale === "en-US") {
                return countryRegionIndex["enUsIndex"];
            }
            return countryRegionIndex["zhCNIndex"];
        },
        selectedText() {
            return this.options[this.selectedValue];
        }
    }
});
</script>

<style lang="less" scoped></style>
